module.exports = __webpack_public_path__ + "static/media/05gift.df2c0ace.png";